import { isSupabaseConfigured } from '../../../lib/services';
import { supabase } from '../../../lib/supabase';
import type { PayrollEntry, PayrollFormData } from '../types';

export const payrollService = {
  async getAll(): Promise<PayrollEntry[]> {
    if (!isSupabaseConfigured()) {
      const mockPayroll: PayrollEntry[] = [
        {
          id: 'payroll-1',
          staff_id: 'staff-1',
          month: '2024-01',
          basic_salary: 5000,
          overtime_hours: 10,
          overtime_rate: 25,
          overtime_pay: 250,
          deductions: 200,
          bonus: 500,
          gross_pay: 5750,
          net_pay: 5550,
          status: 'approved',
          created_at: '2024-01-01T00:00:00Z',
          updated_at: '2024-01-01T00:00:00Z'
        }
      ];
      return mockPayroll;
    }
    
    const { data, error } = await supabase
      .from('payroll_entries')
      .select('*')
      .order('month', { ascending: false });
    
    if (error) throw error;
    return data as PayrollEntry[];
  },

  async getByMonth(month: string): Promise<PayrollEntry[]> {
    if (!isSupabaseConfigured()) {
      return [];
    }
    
    const { data, error } = await supabase
      .from('payroll_entries')
      .select('*')
      .eq('month', month)
      .order('created_at');
    
    if (error) throw error;
    return data as PayrollEntry[];
  },

  async create(payroll: PayrollFormData): Promise<PayrollEntry> {
    if (!isSupabaseConfigured()) {
      const mockPayroll: PayrollEntry = {
        ...payroll,
        id: `payroll-${Date.now()}`,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };
      return mockPayroll;
    }
    
    const { data, error } = await supabase
      .from('payroll_entries')
      .insert([{ ...payroll, updated_at: new Date().toISOString() }])
      .select()
      .single();
    
    if (error) throw error;
    return data as PayrollEntry;
  },

  async update(id: string, payroll: Partial<PayrollFormData>): Promise<PayrollEntry | null> {
    if (!isSupabaseConfigured()) {
      const existing = await this.getById(id);
      return {
        ...existing!,
        ...payroll,
        updated_at: new Date().toISOString()
      };
    }
    
    const { data, error } = await supabase
      .from('payroll_entries')
      .update({ ...payroll, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data as PayrollEntry;
  },

  async getById(id: string): Promise<PayrollEntry | null> {
    if (!isSupabaseConfigured()) {
      return {
        id,
        staff_id: 'staff-1',
        month: '2024-01',
        basic_salary: 5000,
        overtime_hours: 10,
        overtime_rate: 25,
        overtime_pay: 250,
        deductions: 200,
        bonus: 500,
        gross_pay: 5750,
        net_pay: 5550,
        status: 'approved',
        created_at: '2024-01-01T00:00:00Z',
        updated_at: '2024-01-01T00:00:00Z'
      };
    }
    
    const { data, error } = await supabase
      .from('payroll_entries')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data as PayrollEntry;
  }
};
